import Cookies from 'js-cookie'
import router from '../router'

const mutations = {

    //
    // //是否登录
    // isLogin (state, userMessage) {
    //     //userMessage用户信息
    //     if (userMessage) {
    //         Cookies.set("_user", userMessage, {expires: 7, path: '/'})
    //         state.isLogin = true;
    //
    //     } else {
    //         state.isLogin = false;
    //         Cookies.remove('_user', {path: '/'})
    //     }
    // },
    //

};

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js